import { Select, Form } from 'antd'
import React, { useEffect, useState } from 'react'
import { get } from '../../api/auth'
import { getResourceUrl } from '../../api/consts'
import { useAuth } from '../../context/AuthProvider'
import { getCurrentLangISO } from '../../i18n'

const LanguageList = ({ name, inputName, placeholder }) => {
  const [loading, setLoading] = useState(true)
  const [options, setOptions] = useState([])
  const { token, apiHost } = useAuth()

  useEffect(() => {
    getResource((result) => {
      if (result) {
        setOptions(
          Object.keys(result).map((key) => {
            const lang = result[key].name.filter((lang) => {
              return lang.language === getCurrentLangISO()
            })[0]
            return {
              value: result[key]._id,
              label: lang.name,
            }
          })
        )
        setLoading(false)
      }
    })
  }, [])

  const getResource = async (onSuccess) => {
    const result = await get(getResourceUrl(apiHost, name), token)
    if (!result['errors']) {
      onSuccess(result.items)
    }
  }
  return (
    <Form.Item name={inputName} noStyle>
      <Select placeholder={placeholder} loading={loading} options={options} />
    </Form.Item>
  )
}

export default LanguageList
